import { render, staticRenderFns } from "./Parceria_Prefeitura_SP.vue?vue&type=template&id=4a6f3cc7"
import script from "./Parceria_Prefeitura_SP.vue?vue&type=script&lang=js"
export * from "./Parceria_Prefeitura_SP.vue?vue&type=script&lang=js"
import style0 from "./Parceria_Prefeitura_SP.vue?vue&type=style&index=0&id=4a6f3cc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports